// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"qg","result_page":"rg","what_are_calories":"sg","title":"tg","copy":"ug","chart":"vg","to_reach":"wg","title_wrapper":"xg","rhode_percent":"yg","what_are_macro":"zg","text":"Ag","img":"Bg","macros_wrapper":"Cg","macros":"Eg","macro_item":"Fg","value":"Gg","note":"Hg","btn":"Ig","carbo_item":"Jg","faq":"Kg","faq_items":"Lg"};
    if(module.hot) {
      // 1715188223390
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  